import { Block } from 'webiq.boilerplate'

export default class CheckoutProduct extends Block {
	static title = 'checkout-product'

	init() {
		this.input = this.getElement('count')
		this.plus = this.getElement('plus[data-plus]')
		this.min = this.getElement('min[data-min]')
		this.deleteButton = this.getElement('delete')
		this.form = this.getElement('number')

		if (this.plus) {
			this.plus.addEventListener('click', () => {
				this.setButtonsLoading(true)
				this.input.value = parseInt(this.input.value, 10) + 1
				this.dataLayer('add_to_cart', 1)
				this.setUpdateLoading()
				this.form.submit()
			})
		}

		if (this.min) {
			this.min.addEventListener('click', () => {
				this.setButtonsLoading(true)
				this.input.value = Math.max(parseInt(this.input.value, 10) - 1, 0)
				this.dataLayer('remove_from_cart', 1)
				this.setUpdateLoading()
				this.form.submit()
			})
		}

		// if (this.input !== null) {
		// 	this.input.addEventListener('keyup', () => {
		// 		if (!this.input.max) {
		// 			return
		// 		}
		// 		this.input.value = Math.min(
		// 			parseInt(this.input.value, 10),
		// 			this.input.max,
		// 		)
		// 	})

		// 	const currentCount = this.getElement('count').value
		// 	this.input.addEventListener('sl-change', () => {
		// 		if (currentCount && this.input.value) {
		// 			if (this.input.value > currentCount) {
		// 				this.dataLayer('add_to_cart', this.input.value - currentCount)
		// 			} else if (this.input.value < currentCount) {
		// 				this.dataLayer('remove_from_cart', currentCount - this.input.value)
		// 			}
		// 		}
		// 		this.setUpdateLoading()
		// 		this.form.submit()
		// 	})
		// }

		if (this.deleteButton) {
			this.deleteButton.addEventListener('click', () => {
				this.removeItem(true)
			})
		}
	}

	removeItem(deleteAction = false) {
		this.setButtonsLoading(true, deleteAction)
		if (!deleteAction) {
			this.setUpdateLoading()
		}
		this.deleteButton.classList.add('shoppingcart-product__delete--active')
		const id = this.element.getAttribute('data-shoppingcart-product-id')
		const url = '/checkout/delete/' + id

		fetch(url, {
			method: 'DELETE',
		})
			.then((response) => this.handleAddResponse(response))
			.catch((error) => this.handleError(error))
	}

	handleAddResponse(response) {
		// this.setButtonsLoading(false)
		if (response.error) {
			return
		} else {
			this.dataLayer('remove_from_cart', this.getElement('count').value)
			window.location.reload()
		}
	}

	setButtonsLoading(bool, deleteAction = false) {
		if (bool) {
			this.plus.disabled = true
			this.min.disabled = true
			this.deleteButton.disabled = true
			if (deleteAction) {
				this.deleteButton.querySelector('[data-loader]').classList.remove('tw-hidden')
				this.deleteButton.querySelector('[data-cross]').style.display = "none"
			}
		} else {
			this.plus.disabled = false
			this.min.disabled = false
			this.deleteButton.disabled = false
			if (deleteAction) {
				this.deleteButton.querySelector('[data-loader]').classList.add('tw-hidden')
				this.deleteButton.querySelector('[data-cross]').style.display = "var(--fa-display,inline-block)"
			}
		}
	}

	setUpdateLoading() {
		const inputSpinner = this.getElement('count-spinner')
		const overlay = this.getElement('overlay')

		this.input.classList.add('tw-invisible')
		inputSpinner.classList.remove('tw-hidden')
		overlay.classList.remove('tw-hidden')
	}

	dataLayer(type, count) {
		if ('dataLayer' in window) {
			window.dataLayer.push({ ecommerce: null })
			window.dataLayer.push({
				shoppingcartId: parseInt(document.querySelector('input[name="analytics-id"]').value),
				event: type,
				ecommerce: {
					currency: "EUR",
					currency_user: this.element.getAttribute('data-currency') ? this.element.getAttribute('data-currency') : "EUR",
					value: parseFloat(this.element.getAttribute('data-product-price')) * parseInt(count),
					value_user: parseFloat(this.element.getAttribute('data-product-price-user')),
					items: [
						{
							item_id: this.element.getAttribute('data-product-ean') ? this.element.getAttribute('data-product-ean') : this.element.getAttribute('data-product-id'),
							item_group_id: this.element.getAttribute('data-product-id'),
							item_name: this.element.getAttribute('data-product-name'),
							price: parseFloat(this.element.getAttribute('data-product-price')),
							price_user: parseFloat(this.element.getAttribute('data-product-price-user')),
							item_category: this.element.getAttribute('data-product-category'),
							item_variant: this.element.getAttribute('data-product-variant'),
							quantity: count,
							google_business_vertical: "retail",
							id: this.element.getAttribute('data-product-ean') ? this.element.getAttribute('data-product-ean') : this.element.getAttribute('data-product-id'),
						},
					],
				},
			})
		}
	}
}
